import { COLOR, FONT_SIZE, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivReviewRoot = styled.div`
  display: grid;
  margin-top: 8px;
  word-break: break-all;

  ${mq.sp} {
    margin-top: 4px;
  }
`;

export const BtnOpenText = styled.button`
  margin-top: 8px;
  color: ${COLOR.BLUE900.code};

  ${mq.sp} {
    margin-top: 4px;
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const ParSpoilerAlertMessage = styled.p`
  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;
